export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";